let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Ldtt")).then(() => parcelRequire('2ePj5'));